import React, { useEffect } from 'react'
import HealtheraTable from '../Table/Table'
import { Loading } from '../../healtheraComponents'
import { useSelector, useDispatch } from "react-redux"
import * as actions from '../../redux/geozones'
import { withRouter } from 'react-router'

const GeozonesList = (props) => {
  const { geozones, fetching } = useSelector(state => state.geozones)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(actions.getGeozones())
  }, [dispatch])

  return (
    <>
      {!fetching && geozones && <HealtheraTable
        muted={true} paddingtop={`27px`}
        data={prepareData(geozones)} />}
      <Loading loading={fetching} />
    </>
  )
}
export default withRouter(GeozonesList)

const prepareData = (geozones = []) => {
  return geozones.reduce((data, geozone = {}) => {
    const { name, _id, code } = geozone
    data.push({ view: { name: name || '', code: code }, ID: _id, route: 'region' })
    return data
  }, [
    {
      view: {
        name: 'Region Name',
        code: 'Region Code'
      },
      headers: true
    }, 
    {
      view: {
        name: 'Referral Pharmacies',
        code: 'CPD',
      },
      route: 'commission-delivery-partner',
      skipId: true,
    },
    {
      view: {
        name: 'E-Commerce Activated Pharmacies',
        code: 'OTC',
      },
      route: 'e-commerce-activated-pharmacies',
      skipId: true,
    },
  ])
};
